/**
 * å»é¢ç­çº§çæä¸¾ç±»
 */
export enum TenantLevel {
  FIRST_A = 'ä¸çº§ç²ç­',
  FIRST_B = 'ä¸çº§ä¹ç­',
  FIRST_C = 'ä¸çº§ä¸ç­',
  SECOND_A = 'äºçº§ç²ç­',
  SECOND_B = 'äºçº§ä¹ç­',
  SECOND_C = 'äºçº§ä¸ç­',
  THIRD_A = 'ä¸çº§ç²ç­',
  THIRD_B = 'ä¸çº§ä¹ç­',
  THIRD_C = 'ä¸çº§ä¸ç­',
  THIRD_S = 'ä¸çº§ç¹ç­',
  OTHERS = 'å¶ä»'
}
